import type { InstagramCreator, InstagramCreatorDailyEntry, Maybe } from '@frontend/gql/social/graphql';
import { useInstagramSocialStats } from '@/applications/Social/creator-search/instagram/hooks/useInstagramSocialStats';

export type SocialStatTabKey = 'engagements' | 'reach';

// Legacy interface for backward compatibility
export interface SocialStatsSectionProps {
  activeSocialStatTab: SocialStatTabKey;
  setActiveSocialStatTab: (tab: SocialStatTabKey) => void;
  isLoading: boolean;
  engagementsData: InstagramCreatorDailyEntry[];
  reachData: InstagramCreatorDailyEntry[];
}

export const useSocialStatsProps = (
  isLoading: boolean,
  creator?: Maybe<InstagramCreator>,
  defaultTab: SocialStatTabKey = 'engagements',
) => {
  // Use the new generic hook which returns the props the shared component expects
  return useInstagramSocialStats(isLoading, creator, defaultTab);
};
